module.exports = __webpack_public_path__ + "img/solution-v2x-system-pic-02.975493ba.png";